'use strict';

var MAX_NOTIFICATIONS = 50;

require('./CompanyLogoService.js');
require('./CompanyInfoService.js');
require('./categories/CompanyCategoryService.js');
require('./groups/CompanyGroupService.js');
require('./CompanyService.js');

function CompanyNavCtrl(
  $scope,
  $rootScope,
  $state,
  $stateParams,
  $timeout,
  $window,
  $translate,
  logo,
  info,
  categories,
  customerPortals,
  tags,
  config,
  priorities,
  currentUser,
  publicationTypes,
  currentUserPermissions,
  CompanyNotificationsService,
  userInformation
) {
  var searchTimeout;
  $scope.currentUserPermissions = currentUserPermissions;
  $scope.logo = logo;
  $scope.info = info;
  $scope.userInfo = userInformation;
  $scope.categories = categories;
  $scope.customerPortals = customerPortals;
  $scope.tags = tags;
  $scope.priorities = priorities;
  $scope.portalUrl = config.portalUrl
  priorities.$promise.then(function () {
    for (var i = 0; i < priorities.length; i++) {
      if (priorities[i].id === $scope.priorityId) {
        $scope.selectedPriority = priorities[i];
      }
      $scope.priorities[priorities[i].id] = priorities[i];
    }
  });
  $scope.types = publicationTypes;
  $scope.showAll = $stateParams.showAll || false;

  function loadData(offset){
    CompanyNotificationsService.queryNotificationsUser({userId: currentUser.id, offset: offset, limit: MAX_NOTIFICATIONS}, function(notificationsObject){
      if(offset === 0){
        $rootScope.notifications = notificationsObject.notifications;
      }else{
        $rootScope.notifications = $rootScope.notifications.concat(notificationsObject.notifications);
      }
      $rootScope.notificationsUnread = notificationsObject.unView;
    });
  }

  loadData(0);

  $scope.$on('notification', function() {
    $scope.$apply(function() {
      $rootScope.notificationLimit = MAX_NOTIFICATIONS;
      loadData(0);
    });
  });

  $scope.$on('eventReadNotification', function() {
    $scope.$apply(function() {
      $rootScope.notificationsUnread = 0;
      angular.forEach($rootScope.notifications, function(notification){
        notification.viewed = true;
      });
    });
  });

  $scope.closeNotifications = function() {
    if (!$scope.preventBlur) {
      $scope.notificationsOpen = false;
    }

    $scope.preventBlur = false;
  };

  $rootScope.notificationLimit = MAX_NOTIFICATIONS;
  $scope.toggleNotificationsOpen = function(preventBlur) {
    $scope.notificationsOpen = $scope.notificationsOpen ? false : true;

    if (preventBlur) {
      $scope.preventBlur = true;
    }

    setTimeout(function(){
      if($rootScope.notificationsUnread > 0){
        CompanyNotificationsService.update({companyId: $stateParams.companyId}, {}, function(){
          $rootScope.notificationsUnread = 0;
          angular.forEach($rootScope.notifications, function(notification){
            notification.viewed = true;
          });
        });
      }
    }, 5000);
  };

  $scope.loadMoreNotifications = function() {
    loadData($rootScope.notificationLimit + 1);
    $rootScope.notificationLimit = $rootScope.notificationLimit + MAX_NOTIFICATIONS;
  };

  $scope.toggleSidebarAdvancedSearch = function() {
    if($state.current.name !== 'root.company.publications-list'){
      $state.go('root.company.publications-list', {showAll: true});
    }
    $rootScope.$broadcast('advancedSearchSidebarToggle');
  };

  $scope.toggleMenuTop = function() {
    if($state.current.name === 'root.company.menu'){
      window.history.back();
    }else{
      $state.go('root.company.menu');
    }
  };

  function getCompanyById(companies, companyId) {
    var ret = false;

    companies.forEach(function(c) {
      if(c.id === companyId) {
        ret = c;
      }
    });

    return ret;
  }

  $scope.currentCompany = getCompanyById($scope.companies, $stateParams.companyId);

  $scope.filter = {
    q:     $state.params.q || null,
    qType: $state.params.qType || "GENERAL",
    qTypeObject: $state.params.qTypeObject || "OBJECT",
    page:  null
  };

  $scope.$on('$stateChangeSuccess', function() {
    if(!searchTimeout) {
      $scope.filter.q     = $state.params.q;
      $scope.filter.qType = $state.params.qType || "GENERAL";
      $scope.filter.qTypeObject = $state.params.qTypeObject || "OBJECT";
    }
  });

  if($scope.filter.qTypeObject === 'CUSTOMER'){
    $scope.placeholderSearch = $translate.instant('search-customer');
  }else{
    if($scope.filter.qTypeObject === 'PRODUCT'){
      $scope.placeholderSearch = $translate.instant('search-products');
    }else{
      if($scope.filter.qTypeObject === 'ARCHIVED'){
        $scope.placeholderSearch = $translate.instant('search-archive');
      }else{
        $scope.placeholderSearch = $translate.instant('search-object');
      }
    }
  }

  $scope.$watchCollection("[filter.q, filter.qType, filter.qTypeObject]", function(newValues, oldValues) {
    var newQ = newValues[0] || "";
    var oldQ = oldValues[0] || "";

    if($scope.filter.qTypeObject === 'CUSTOMER'){
      $scope.placeholderSearch = $translate.instant('search-customer');
    }else{
      if($scope.filter.qTypeObject === 'PRODUCT'){
        $scope.placeholderSearch = $translate.instant('search-products');
      }else{
        if($scope.filter.qTypeObject === 'ARCHIVED'){
          $scope.placeholderSearch = $translate.instant('search-archive');
        }else{
          $scope.placeholderSearch = $translate.instant('search-object');
        }
      }
    }

    /* If we have a string and a change, it is either q or qType.
       If we do not have a string but the string is changed, then user might want
       unfiltered list */
    if(newQ.trim().length > 0 || newQ !== oldQ) {
      if(searchTimeout){
        $timeout.cancel(searchTimeout);

        searchTimeout = null;
      }

      searchTimeout = $timeout(function () {
        if (angular.isDefined(newValues[0])) {
          if($scope.filter.qTypeObject === 'OBJECT'){
            $state.go('root.company.publications-list', $scope.filter);
          }else{
            if($scope.filter.qTypeObject === 'ARCHIVED'){
              $scope.filter.companyId = $stateParams.companyId;
              $scope.filter.queryArchived = $scope.filter.q;
              $state.go('root.company.publications-listArchived', $scope.filter);
            }
          }

          searchTimeout = null;
        }
      }, 300);
    }
  });
  
  if($scope.filter.q){
    setTimeout(function(){
      $scope.searchObjectsFocus(true);
    }, 50);
  }

  $scope.searchObjectsFocus = function(publicationSearchFocus){
    if(publicationSearchFocus){
      var widthWindowH = angular.element($window).width();
      if(widthWindowH > 807){
        var widthLogo = 253;
        if(widthWindowH < 999){
          widthLogo = 151;
        }
        angular.element('.header__nav').css('width', (widthWindowH-widthLogo)+'px');
        angular.element('.header__nav .header__search').css('width', (widthWindowH-widthLogo-59)+'px');
      }
    }else{
      angular.element('.header__nav').css('width', 'inherit');
      angular.element('.header__nav .header__search').css('width', 'inherit');
    }
  };
}

CompanyNavCtrl.resolve = {
  logo: ['$stateParams', 'CompanyLogoService', function($stateParams, CompanyLogoService) {
    return CompanyLogoService.get({companyId: $stateParams.companyId}).$promise;
  }]
};
module.exports = CompanyNavCtrl;

angular.module('dokiv')
  .controller('CompanyNavCtrl', [
    '$scope',
    '$rootScope',
    '$state',
    '$stateParams',
    '$timeout',
    '$window',
    '$translate',
    'logo',
    'info',
    'categories',
    'customerPortals',
    'tags',
    'config',
    'priorities',
    'currentUser',
    'publicationTypes',
    'currentUserPermissions',
    'CompanyNotificationsService',
    'userInformation',
    CompanyNavCtrl
  ]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/CompanyNavCtrl.js
// module id = 313
// module chunks = 0